import { bootstrapApplication } from '@angular/platform-browser';
import { appConfig } from './app/app.config';
import { AppComponent } from './app/app.component';
import { initializeMsal } from './app/core/msal/msal-instance.factory';

initializeMsal()
  .catch(err => console.error('MSAL initialization failed', err))
  .finally(() => {
    bootstrapApplication(AppComponent, appConfig).catch((err) => console.error(err));
  });